import { useAuth } from '../auth/useAuth';

export function Login() {
  const { login, isAuthenticated } = useAuth();

  if (isAuthenticated) {
    window.location.href = '/';
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'var(--color-bg)',
      }}
    >
      <div
        className="card"
        style={{
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%',
          padding: '3rem 2rem',
        }}
      >
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Salesforce Backup</h1>
        <p style={{ color: 'var(--color-text-muted)', marginBottom: '2rem' }}>
          Restore Portal
        </p>
        <button
          onClick={login}
          style={{
            width: '100%',
            padding: '0.75rem',
            fontSize: '1rem',
          }}
          aria-label="Sign in with Microsoft Entra ID"
        >
          Sign In with Microsoft
        </button>
        <p
          style={{
            marginTop: '1.5rem',
            fontSize: '0.75rem',
            color: 'var(--color-text-muted)',
          }}
        >
          You will be redirected to your organization's identity provider.
        </p>
      </div>
    </div>
  );
}
